/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'hard' }, { id: 'partly' }, { id: 'none' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-barber-struggle"
      progress={80}
      field="hairstyleBarberStruggle"
      setter="setHairstyleBarberStruggle"
      ns="hairstyleBarberStruggle"
      options={OPTIONS}
      hasSubtitle
    />
  );
}

export default Page;
